import { useState } from 'react'
import { Head } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import ForgeStage from '@/frontend/features/Fde/ForgeStage'
import ProjectControls from '@/frontend/features/Fde/ProjectControls'
import ProjectDialog from '@/frontend/features/Fde/ProjectDialog'
import ProjectSettings from '@/frontend/features/Fde/ProjectSettings'
import { fdeRoutes } from '@/frontend/features/Fde/routes'
import type { ManagementProps } from '@/frontend/features/Fde/types'

function SettingsPage(props: ManagementProps) {
  const [newProjectOpen, setNewProjectOpen] = useState(false)
  const actions = <ProjectControls path={fdeRoutes.settings} project={props.project} projects={props.project_history} copy={props.copy} canManage={props.can_manage_access} onNew={() => setNewProjectOpen(true)} />

  return <>
    <Head title={props.page_title} />
    <FdeShell copy={props.copy} eyebrow="" title={props.project?.name ?? props.organization.name} description={props.copy.management.settings_description} actions={actions} projectId={props.project?.id}>
      <ForgeStage props={props} primaryLabel={props.copy.management.settings} renderPrimary={() => <ProjectSettings props={props} />} />
    </FdeShell>
    <ProjectDialog open={newProjectOpen} onOpenChange={setNewProjectOpen} project={null} agents={props.agents} copy={props.copy} activeProjectId={props.project?.id} returnTo="settings" />
  </>
}

SettingsPage.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
export default SettingsPage
